// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import Header from './components/Header';
import NewsList from './components/NewsList';
import NewsDetail from './components/NewsDetail';
import PageTracker from './components/PageTracker'; // ← 追加
import Ranking from "./components/Ranking";
import Signup from "./components/Signup";
import Login from './pages/Login';
import FavoriteList from './components/FavoriteList'; // 追加


const theme = createTheme({
  shape: {
    borderRadius: 16, // 全体の角丸を16pxに設定
  },
  palette: {
    primary: {
      main: '#1d1d1f', // Appleサイトのダークテキストに近い色
    },
    text: {
      primary: '#1d1d1f',
      secondary: '#3a3a3c',
    },
    background: {
      default: '#F5F5F7', // 薄いグレーの背景
      paper: '#FFFFFF',   // カードやペーパーコンポーネントは白
    },
  },
  typography: {
    fontFamily: '"San Francisco", "Helvetica Neue", "Arial", sans-serif',
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <PageTracker /> {/* ← 追加: ページ遷移時にGA4へ送信 */}
        <Header />
        <Routes>
          <Route path="/" element={<NewsList />} />
          <Route path="/article/:id" element={<NewsDetail />} />
          <Route path="/ranking" element={<Ranking />} />
          <Route path="/Signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/favorites" element={<FavoriteList />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
